import {
  Chip,
  Stack,
  IconButton,
  TextField,
  Autocomplete,
  InputLabel as MuiInputLabel,
  styled
} from '@mui/material';
import '@mui/material';
import { RiCloseLine } from '@remixicon/react';

import palette from '../theme/palette';

const InputLabel = styled(MuiInputLabel)({
  fontFamily: 'Reddit Sans',
  fontWeight: 500,
  fontSize: 11,
  color: palette.grey[500],
  lineHeight: '14px'
});

interface MultiSelectProps {
  placeholder: string;
  options: string[];
  value: string[];
  startLabel?: string;
  endLabel?: string;
  onChange: (value: string[]) => void;
}

const MultiSelect = ({
  options,
  value,
  onChange,
  placeholder,
  startLabel,
  endLabel
}: MultiSelectProps) => (
  <Stack gap={1}>
    {startLabel && <InputLabel>{startLabel}</InputLabel>}
    <Autocomplete
      clearIcon={false}
      options={options}
      freeSolo
      multiple
      limitTags={6}
      value={value}
      onChange={(e, value) => onChange(value)}
      renderTags={(value, props) =>
        value.map((option, index) => (
          <Chip
            size="small"
            label={option}
            {...props({ index })}
            key={`${value}-${index}`}
            deleteIcon={
              <IconButton
                sx={{
                  '&:hover': {
                    background: 'transparent'
                  }
                }}
              >
                <RiCloseLine size={18} />
              </IconButton>
            }
            sx={{
              background: palette.grey[800],
              height: '22px',
              color: palette.black
            }}
          />
        ))
      }
      renderInput={params => (
        <TextField
          {...params}
          fullWidth
          size="small"
          placeholder={value.length === 0 ? placeholder : ''}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: '7px',
              background: palette.white,
              fontSize: 13
            }
          }}
          onBlur={e => {
            const trimmed = e.target.value.trim();
            if (trimmed && !value.includes(trimmed)) {
              onChange([...value, trimmed]);
            } else {
              onChange(value);
            }
          }}
        />
      )}
    />
    {endLabel && <InputLabel>{endLabel}</InputLabel>}
  </Stack>
);

export default MultiSelect;
